import React, { useState, useEffect } from "react";
import i18next from "i18next";

import flagUs from "../../images/flags/us.svg";
import flagRu from "../../images/flags/ru.svg";


const LanguageSwitcher = () => {
  const [currentLang, setCurrentLang] = useState("en");

  const changeLanguage = (newValue) => {
    setCurrentLang(newValue);
    i18next.changeLanguage(newValue);
    localStorage.setItem("languagePreference", newValue);
  };

  useEffect(() => {
    const languagePreference = localStorage.getItem("languagePreference");
    if (languagePreference) {
      setTimeout(() => {
        setCurrentLang(languagePreference);
        i18next.changeLanguage(languagePreference);
      }, 50);
    }
  }, []);

  return (
    <div className="lang-selector dropdown">
      <button
        className="btn btn-link dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {currentLang}
      </button>
      <ul className="dropdown-menu dropdown-menu-end user-menu py-2" aria-labelledby="Select language">
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage("en")}>
            <img src={flagUs} alt="US English" /> English
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage("ru")}>
            <img src={flagRu} alt="Russian" /> Русский
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
